import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import cx from 'classnames';
import { Tracking } from 'web-core/src/tracking';
import PictureCard from 'client/components/card/pictureCard';
import ExpenseRow from 'client/components/tax/expenseRow';
import Translate from 'client/components/translate';
import LinkButton from 'client/components/button/linkButton';
import { ProfessionShape, ExpenseShape } from 'client/constants/tax/shapes';
import 'client/styles/tax/expenseHero.scss';

const propTypes = {
  className: PropTypes.string,
  featuredExpenses: PropTypes.arrayOf(ExpenseShape),
  professions: PropTypes.arrayOf(ProfessionShape),
  hasDefaultProfessions: PropTypes.bool,
  editLinkOut: PropTypes.bool,
  trackingNamePrefix: PropTypes.string,
};
const defaultProps = {
  className: '',
  featuredExpenses: [],
  professions: [],
  hasDefaultProfessions: null,
  editLinkOut: false,
  trackingNamePrefix: 'Deduction Guide:',
};

export default class ExpenseHero extends PureComponent {
  static propTypes = propTypes;
  static defaultProps = defaultProps;

  onEditClick = () => {
    const { trackingNamePrefix, hasDefaultProfessions } = this.props;

    Tracking.track(`${trackingNamePrefix} Action`, {
      Type: 'add-jobs',
      Returning: !hasDefaultProfessions,
    });
  };

  render() {
    const { className, professions, featuredExpenses, hasDefaultProfessions, editLinkOut } =
      this.props;
    if (!professions.length) {
      return null;
    }

    let editUrl = '/deductions/select-job';
    let title = <Translate path="taxes.expenseHero.generic.title" />;
    let description = <Translate path="taxes.expenseHero.generic.description" />;

    if (!hasDefaultProfessions) {
      const editUrlParams = professions
        .map(profession => `selected=${profession.seoSlug}`)
        .join('&');
      editUrl = `/deductions/select-job?${editUrlParams}`;

      if (professions.length > 1) {
        description = professions.map(item => item.displayName).join(', ');
      } else {
        title = (
          <Translate
            path="taxes.expenseHero.single.title"
            using={{ professionName: professions[0].professionTitle }} />
        );
        description = professions[0].introDescription;
      }
    }

    return (
      <div className={cx('expense-hero', className)}>
        <div className="center-col">
          <PictureCard className="white-bg">
            <div className="content">
              <div className="flex-row">
                <h2 className="title flex-child-expand pad-right">{title}</h2>
                {editLinkOut ? (
                  <a href={`/tax${editUrl}`} className="edit pad-left" onClick={this.onEditClick}>
                    <span className="circle">
                      <span className="icon-pencil" />
                    </span>
                  </a>
                ) : (
                  <Link to={editUrl} className="edit pad-left" onClick={this.onEditClick}>
                    <span className="circle">
                      <span className="icon-pencil" />
                    </span>
                  </Link>
                )}
              </div>
              <p className="description">{description}</p>
              {featuredExpenses && featuredExpenses.length > 0 && (
                <div className="featured-expenses">
                  {featuredExpenses.map(item => (
                    <ExpenseRow
                      key={item.id}
                      className="expense"
                      header={item.displayName}
                      description={item.helpText}
                      illustration={item.illustration} />
                  ))}
                  <div className="text-center pad-y">
                    <LinkButton
                      className="cta-button"
                      href={
                        hasDefaultProfessions
                          ? '/tax/deductions/select-job'
                          : `/tax/deductions/${professions.map(p => p.seoSlug).join('/')}`
                      }>
                      <Translate path="taxes.expenseHero.cta.viewFullList" />
                    </LinkButton>
                  </div>
                </div>
              )}
            </div>
          </PictureCard>
        </div>
      </div>
    );
  }
}
